import React from 'react';
import '@/App.css';
import '@/i18n';
import { BrowserRouter, Routes, Route, Navigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Layout from '@/components/Layout';
import ScrollToTop from '@/components/ScrollToTop';
import Home from '@/pages/Home';
import Privacy from '@/pages/Privacy';
import Cookies from '@/pages/Cookies';
import Terms from '@/pages/Terms';
import ThankYou from '@/pages/ThankYou';
import NotFound from '@/pages/NotFound';

const SUPPORTED = ['ar', 'en'];

function LangGate({ children }) {
  const { lang } = useParams();
  const { i18n } = useTranslation();
  React.useEffect(() => {
    if (lang && SUPPORTED.includes(lang) && i18n.language !== lang) {
      i18n.changeLanguage(lang);
      document.documentElement.lang = lang === 'ar' ? 'es-AR' : 'en';
    }
  }, [lang, i18n]);
  if (!SUPPORTED.includes(lang)) return <Navigate to="/ar" replace />;
  return children;
}

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Navigate to="/ar" replace />} />
        <Route path="/thank_you" element={<ThankYou />} />
        <Route path="/:lang" element={<LangGate><Layout /></LangGate>}>
          <Route index element={<Home />} />
          <Route path="privacidad" element={<Privacy />} />
          <Route path="privacy" element={<Privacy />} />
          <Route path="cookies" element={<Cookies />} />
          <Route path="terminos" element={<Terms />} />
          <Route path="terms" element={<Terms />} />
          <Route path="*" element={<NotFound />} />
        </Route>
        <Route path="*" element={<Navigate to="/ar" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
